import { getEnvironment } from '@minecraft.environment';
import { PRODUCTION } from '../constants';

export const getApolloDevtoolsOptions = (): { enabled: boolean } => ({
  enabled: getEnvironment()?.ENV !== PRODUCTION,
});
